
import { DateTime } from "luxon";

const randomChoice = ary => {
    return ary[Math.floor(Math.random() * ary.length)];
}

const pixelPadTimeline = (width, bounds, limits, buffer) => {
    const bounds_dur = bounds.toDuration();
    const buffer_dur = buffer / (width - 2 * buffer) * bounds_dur;

    const earliest_dt = limits.start.minus(buffer_dur);
    const latest_dt = limits.end.plus(buffer_dur);

    return [earliest_dt, latest_dt];
}

function* zip(...args) {
	const iterators = args.map(x => x[Symbol.iterator]());
	while (true) {
		const current = iterators.map(x => x.next());
		if (current.some(x => x.done)) {
			break;
		}
		yield current.map(x => x.value);
	}
}

function pairwise(ary) {
	let ary1 = ary.slice();
    let ary2 = ary.slice();

    ary1.pop()
    ary2.shift();
  
    return zip(ary1, ary2);
}

export {randomChoice, pixelPadTimeline, zip, pairwise};